import { routes } from "./routes";
import { assistantPageCodeEnum } from "features/AssistantPages/constantTypes";

export const CHAT_ELIGIBLE_ROUTES: Array<{
  route: string;
  code: assistantPageCodeEnum;
}> = [
  {
    route: routes.private.viewProperties,
    code: assistantPageCodeEnum.VIEW_PROPERTY,
  },
];
